// import React from 'react'
// // import '../src/assets/styles/home.css';
// import Tilt from "react-parallax-tilt";
// import {
//   AiFillGithub,
//   AiOutlineTwitter,
//   AiFillInstagram,
// } from "react-icons/ai";
// import { FaLinkedinIn } from "react-icons/fa";


// const Home = () => {
//   return (
//     <div>
//         <section id="home" className="hero">
//       <div className="hero-text">
//         <h2>
//           Hi There! <span className="wave">👋🏻</span>
//         </h2>
//         <h1>
//           I'M <span className="purple-1">SHIBIL KHAN</span>
//         </h1>
//         <h3 className="typing">
//           FRONTEND DEVELOPER
//           {/* MERN Stack Developer */}
//         </h3>
//       </div>
//       <div className="hero-img">
//         <img src={'home-1.png'} alt="Coder Illustration" />
//       </div>
//     </section>

//     <section className="intro-section">
//       <div className="intro-container">
//         <div className="intro-text">
//           <h1>
//             LET  ME <span className="highlight">INTRODUCE</span> MYSELF
//           </h1>
//           <p>
//            I fell in love with programming and have been learning and improving every day 🤷‍♂️
//           </p>
// <p>
// I specialize in <em className="purple-2">JavaScript</em> and modern frontend development.
// </p>
// <p>
// My interests focus on creating innovative{" "}
// <em className="purple-2">Web Technologies and Products</em> that deliver seamless user experiences.
// </p>
// <p>
// I also work with <em className="purple-2">Node.js</em> and{" "}
// <em className="purple-2">modern JavaScript frameworks</em> like{" "}
// <em>React.js</em> and <em>Next.js</em>.
// </p>

//         </div>

//         <Tilt>
//         <div className="intro-avatar">
//           <img src={'https://raw.githubusercontent.com/soumyajit4419/Portfolio/24d955cf6cd4ce5ff8a9a8071f0c87dfa4aaacec/src/Assets/avatar.svg'} alt="avatar" />
//         </div>
//         </Tilt>
//       </div>

//       <div className="social-section">
//         <h2>FIND ME ON</h2>
//         <p>
//           Feel free to <span className="highlight">connect</span> with me
//         </p>
       
//         <ul>
//         <li className="social-icons a">
//                 <a
//                   href="https://github.com/Shibilkhan999"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="icon-colour  home-social-icons"
//                 >
//                   <AiFillGithub />
//                 </a>
//         </li>
//         <li className="social-icons">
//                 <a
//                   href="https://twitter.com"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="icon-colour  home-social-icons"
//                 >
//         <AiOutlineTwitter />
//         </a>
//          </li>
//               <li className="social-icons">
//                 <a
//                   href="https://www.linkedin.com/in/shibil-khan-/"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="icon-colour  home-social-icons"
//                 >
//                   <FaLinkedinIn />
//                 </a>
//               </li>
//               <li className="social-icons">
//                 <a
//                   href="https://www.instagram.com/shibilkhan.official"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="icon-colour home-social-icons"
//                 >
//                   <AiFillInstagram />
//                 </a>
//               </li>
//             </ul>
//       </div>
//     </section>


      
//     </div>
//   )
// }

// export default Home;



import React from "react";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-text">
          <h2>
            Hi There! <span className="wave">👋🏻</span>
          </h2>
          <h1>
            I'M <span className="purple-1">SHIBIL KHAN</span>
          </h1>
          <h3 className="typing">FRONTEND DEVELOPER</h3>
        </div>

        <div className="hero-img">
          <img src="home-1.png" alt="Coder Illustration" />
        </div>
      </section>

      {/* Intro Section */}
      <section className="intro-section">
        <div className="intro-container">
          <div className="intro-text">
            <h1>
              LET ME <span className="highlight">INTRODUCE</span> MYSELF
            </h1>

            <p>
              I fell in love with programming and have been learning and
              improving every day 🤷‍♂️
            </p>

            <p>
              I specialize in <em className="purple-2">JavaScript</em> and modern
              frontend development.
            </p>

            <p>
              My interests focus on creating innovative{" "}
              <em className="purple-2">Web Technologies and Products</em> that
              deliver seamless user experiences.
            </p>

            <p>
              I also work with <em className="purple-2">Node.js</em> and{" "}
              <em className="purple-2">modern JavaScript frameworks</em> like{" "}
              <em>React.js</em> and <em>Next.js</em>.
            </p>
          </div>

          <Tilt>
            <div className="intro-avatar">
              <img
                src="https://raw.githubusercontent.com/soumyajit4419/Portfolio/24d955cf6cd4ce5ff8a9a8071f0c87dfa4aaacec/src/Assets/avatar.svg"
                alt="avatar"
              />
            </div>
          </Tilt>
        </div>

        {/* Social Section */}
        <div className="social-section">
          <h2>FIND ME ON</h2>
          <p>
            Feel free to <span className="highlight">connect</span> with me
          </p>

          <ul>
            <li className="social-icons">
              <a
                href="https://github.com/Shibilkhan999"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <AiFillGithub />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <AiOutlineTwitter />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/shibil-khan-/"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <FaLinkedinIn />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.instagram.com/shibilkhan.official"
                target="_blank"
                rel="noreferrer"
                className="icon-colour home-social-icons"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Home;
